export default "__VITE_ASSET__a5492328__"